import React from "react";

import Zar8YieldCalculatorContent from "../../components/Zar8YieldCalculatorContent";
import Header from "../../layouts/Header";

export default function Zar8Calculator({ basePath = "/zar8/track" }) {
  return (
    <div className="min-h-screen bg-[#F8F8F8]">
      <Header />
      <Zar8YieldCalculatorContent basePath={basePath} />
    </div>
  );
}
